import SettlementDetails from './SettlementDetails';

export default SettlementDetails;
